// ! This file was auto-generated from the k2 OpenAPI schema. Do not override this file.
export const Tags = {
    ActivityLog: "ActivityLog",
    Comment: "Comment",
    Healthchecks: "Healthchecks",
    SigningConfiguration: "SigningConfiguration",
    Stage: "Stage",
    Task: "Task",
    Ticket: "Ticket",
    TicketActions: "TicketActions",
    Workflow: "Workflow",
    WorkflowDocument: "WorkflowDocument",
    WorkflowTemplate: "WorkflowTemplate",
    admin: "admin",
    contract_actions: "contract-actions",
    integrate_workflow: "integrate-workflow",
    schemas: "schemas",
    ticket_actions: "ticket-actions",
    ticket_comments: "ticket-comments",
    ticket_documents: "ticket-documents",
    ticket_esign_packages: "ticket-esign-packages",
    ticket_fields: "ticket-fields",
    ticket_sign_tasks: "ticket-sign-tasks",
    ticket_signing_participants: "ticket-signing-participants",
    ticket_stages: "ticket-stages",
    ticket_tasks: "ticket-tasks",
    tickets: "tickets",
    workflow_documents: "workflow-documents",
    workflow_templates: "workflow-templates",
    workflows: "workflows"
} as const;
export type TagName = (typeof Tags)[keyof typeof Tags];
